export function PageHeading({
  subtitle,
  title,
}: {
  subtitle?: string;
  title: string;
}) {
  return (
    <header>
      <h1 className="text-2xl font-semibold tracking-tight text-ink lg:text-[1.75rem]">
        {title}
      </h1>
      {subtitle ? (
        <p className="mt-1.5 max-w-2xl text-sm leading-6 text-ink-3">
          {subtitle}
        </p>
      ) : null}
    </header>
  );
}
